import React from 'react';

const WhiteArrowIcon = () => {
  return (
    <svg
      width="10"
      height="14"
      viewBox="0 0 10 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.71512 6.26251C9.17569 6.64631 9.17569 7.35369 8.71512 7.73749L1.57469 13.6879C0.949416 14.2089 0.000113494 13.7643 0.000113494 12.9504V1.04964C0.000113494 0.235717 0.949417 -0.208913 1.57469 0.312149L8.71512 6.26251Z"
        fill="white"
      />
    </svg>
  );
};

export default WhiteArrowIcon;
